var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOjoVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9082 16.5371C18.9082 18.7463 17.3412 20.5371 15.4082 20.5371C13.4752 20.5371 11.9082 18.7463 11.9082 16.5371C11.9082 14.3279 13.4752 12.5371 15.4082 12.5371C17.3412 12.5371 18.9082 14.3279 18.9082 16.5371Z",
    stroke: "#E0BA56",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4082 8.53711C10.0119 8.53711 5.44393 11.9004 3.9082 16.5371C5.44391 21.1738 10.0119 24.5371 15.4082 24.5371C20.8045 24.5371 25.3725 21.1738 26.9082 16.5371C25.3725 11.9004 20.8045 8.53711 15.4082 8.53711Z",
    stroke: "#E0BA56",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjoVision);
export default __webpack_public_path__ + "static/media/ojoVision.9dbceb1fb68f916b75b42f01639a6ff1.svg";
export { ForwardRef as ReactComponent };